const alert = () => ({
  error: null,
  warning: null,
  success: null,
})

export { alert }
